/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_Point_4Inputs */

const en_services_svc_full_point_4 = /** @type {(inputs: Services_Svc_Full_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review queues and dashboards for the people who run it`)
};

const lv_services_svc_full_point_4 = /** @type {(inputs: Services_Svc_Full_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudes rindas un paneļi tiem, kas sistēmu vada`)
};

/**
* | output |
* | --- |
* | "Review queues and dashboards for the people who run it" |
*
* @param {Services_Svc_Full_Point_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_point_4 = /** @type {((inputs?: Services_Svc_Full_Point_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_Point_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_point_4(inputs)
	return en_services_svc_full_point_4(inputs)
});